<template>
  <div>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container nav-padding-fix">
          <h1 class="title">
            Taxi St. Job
          </h1>
          <h2 class="subtitle">
            Administratie systeem
          </h2>
        </div>
      </div>
    </section>
    <form v-on:submit.prevent="checkin" class="columns">
      <div class="column is-4 is-offset-4" style="margin-top:8%;">
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <input class="input" type="email" placeholder="Email" v-model="email">
            <span class="icon is-small is-left">
              <i class="fa fa-envelope"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input class="input" type="password" placeholder="Wachtwoord" v-model="password">
            <span class="icon is-small is-left">
              <i class="fa fa-lock"></i>
            </span>
          </p>
        </div>
        <!-- <div class="field">
          <p class="control has-icons-left">
            <input class="input" type="text" placeholder="Eenmalige toegangscode" v-model="totp">
            <span class="icon is-small is-left">
              <i class="fa fa-clock-o"></i>
            </span>
          </p>
        </div> -->
        <div class="field">
          <p class="control">
            <button class="button is-primary" type="submit" :class="{ 'is-loading': isLoading }">
              Login
            </button>
            <p v-if="invalid" class="help is-danger">De gegevens zijn ongeldig</p>
          </p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false,
      invalid: false,
      email: null,
      password: null,
      totp: null
    }
  },
  methods: {
    async checkin () {
      this.invalid = false
      this.isLoading = true

      try {
        await this.$store.dispatch('login', {
          email: this.email,
          password: this.password,
          totp: this.totp
        })
      } catch (error) {
        this.invalid = true
        this.isLoading = false
        return
      }

      this.$router.push({ name: 'receipts.processing' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login.vue